import App from "./App";
import './style/index.css'
//import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';

const rootElement = document.getElementById('root');

if (rootElement) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    // <StrictMode>
      <App />
    // </StrictMode>
  );
}
